import type { StrictTypedTypePolicies } from '../__generated__/StrictTypedTypePolicies';

export const baseTypePolicies: StrictTypedTypePolicies = {
  Mission: {
    fields: {
      lockedStatus: {
        merge: false,
      },
    },
  },
  MissionLockedStatus: {
    keyFields: false,
  },
};
